const NoPage = () => {
    return <h1>404 La p�gina deseada no existe</h1>;
  };
  
  export default NoPage;